export * from './AssessmentResultItem';
import * as AssessmentResult from './components';

export {AssessmentResult};
